export const numberToString = (value: number, fixedDecimal = 2, position = 3, delimiter = ',') => {
  const stringified = value.toFixed(fixedDecimal)
  const expression = `\\B(?=(\\d{${position}})+(?!\\d))`
  const regex = new RegExp(expression, 'g')
  return stringified.replace(regex, delimiter)
}
